import Axios from '../../../common/util/Axios';

export const getBill = (encryptedPurchaseData) => async (dispatch) => {
    try {
      const res = await Axios.get(`/api/dashboard/bill-view/get-bill`, {
        params: { encryptedPurchaseData },
      });

      if (res.status === 200) {
        return res.data.data;
      } else {
        return null;
      }
    } catch (err) {
      console.error(err);
      return null;
  }
};